import { Link } from "react-router-dom";
import shape3 from "../../assets/images/shape/shape3.png";
import shape4 from "../../assets/images/shape/shape4.png";

export default function HomeTwoHeroSection() {
	return (
		<div className="fugu-hero-section2">
			<div className="container">
				<div className="fugu-hero-content fugu-hero-content2">
					<h1 className="wow fadeInUpX" data-wow-delay="0s">
						The leading platform for cryptocurrency traders
					</h1>
					<p className="wow fadeInUpX" data-wow-delay="0.25s">
						We offer a full-fledged long-term rental platform to cryptocurrency users. It plans to use
						blockchain technology to ensure a secure seamless rental experience.
					</p>
					<div className="fugu-hero-btn-wrap wow fadeInUpX" data-wow-delay="0.40s">
						<Link to="contact" className="fugu-btn fugu-round-btn active" >
							Get Started
						</Link>

						<Link to="contact" className="fugu-btn fugu-round-btn" >
							How to Buy & Sell
						</Link>
					</div>
				</div>
			</div>
			<div className="fugu-shape4">
				<img src={shape3} alt="" />
			</div>
			<div className="fugu-shape5">
				<img src={shape4} alt="" />
			</div>
		</div>
	);
}
